import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import { Reveal, SectionKicker } from "@/components/Reveal";
import { SectorBadge } from "@/components/Badges";
import SEO from "@/components/SEO";
import api from "@/lib/api";
import { container } from "@/lib/constants";

export default function CaseStudies() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/public/case-studies").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <PublicLayout>
      <SEO title="Case Studies" description="Anonymised deal case studies across European real estate, private credit, real assets, and late-stage equity." />
      <section className={`${container} py-20 lg:py-24`}>
        <Reveal>
          <SectionKicker>Selected work</SectionKicker>
          <h1 className="pdg-serif text-4xl sm:text-5xl text-foreground max-w-3xl leading-[1.08]">Case studies</h1>
          <p className="mt-6 text-lg text-foreground/80 max-w-2xl leading-8">
            Anonymised outcomes. No client names, no identifying detail — only the shape of the work.
          </p>
        </Reveal>
        {loading ? (
          <p className="mt-12 text-sm text-muted-foreground">Loading…</p>
        ) : (
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {items.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 0.05}>
                <Link to={`/case-studies/${s.slug}`} data-testid="case-study-card">
                  <GlassCard hover className="p-7 h-full flex flex-col">
                    <div className="flex items-center justify-between">
                      <SectorBadge sector={s.sector} />
                      <span className="text-xs text-muted-foreground">{s.size_range}</span>
                    </div>
                    <h2 className="mt-5 pdg-serif text-xl text-foreground leading-snug">{s.title}</h2>
                    <div className="mt-2 text-xs text-muted-foreground">{s.deal_type} &middot; {s.geography}</div>
                    <p className="mt-4 text-sm text-muted-foreground leading-7 flex-1 line-clamp-4">{s.outcome}</p>
                    <span className="mt-5 text-sm text-[hsl(var(--pdg-gold))] pdg-link-underline w-fit">Read the outcome</span>
                  </GlassCard>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
